<template>
    <div class='cleopatra-paytable'>
        <div class="pl-md-5 pr-md-5 row">
            <div class = "pb-0 col-12 col-md-6">
                <div v-for="(value, symbol) in symbols[0]" class = "d-flex justify-content-start align-items-center pb-1"
                    :key="symbol">
                    <img class = "img-fluid  col-3" v-for="img in 3" :key="img" :src="`/fg/v2/games/cleopatra/img/symbols/${symbol}.png`">
                    <span class = "pl-1 amount  col-3 text-nowrap">{{(currentAmount * value) | currency}}</span>
                </div>
            </div>
            <div class = "pb-0 col-12 col-md-6">
                <div v-for="(value, symbol) in symbols[1]" class = "d-flex justify-content-start align-items-center pb-1"
                    :key="symbol">
                    <img class = "img-fluid col-3" v-for="img in 3" :key="img" :src="`/fg/v2/games/cleopatra/img/symbols/${symbol}.png`">
                    <span class = "pl-3 amount  col-3 text-nowrap">{{(currentAmount * value) | currency}}</span>
                </div>
                <div class = "d-flex justify-content-start align-items-center pb-1 flex-column flex-md-row">
                    <div class = "d-flex justify-content-start align-items-center col-12 col-md-6 p-0 side-note">
                        <img class = "img-fluid col-md-6 col-3 p-0" :src="`/fg/v2/games/cleopatra/img/symbols/urn.png`">
                        <div class = "col-md-6 col-8 p-0"><h6 class="p-0 m-0"><strong style="text-transform: uppercase;">{{'urn' | lang}}:</strong></h6> <span>{{'find_2_equal' | lang}}</span></div>
                    </div>
                    <div class = "d-flex justify-content-start align-items-center col-12 col-md-6 p-0 side-note">
                        <img class = "img-fluid col-md-6 col-3 p-0" :src="`/fg/v2/games/cleopatra/img/symbols/scroll.png`">
                        <div class = "col-md-6 col-8 p-0"><h6 class="p-0 m-0"><strong style="text-transform: uppercase;">{{'papirus' | lang}}:</strong></h6> <span>{{'changes_unlucky_symbol' | lang}}</span></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        data() {
            return {
                'odds' : Config.odds
            }
        },
        methods: {
        },
        computed: {
            ...mapGetters(['currentAmount']),
            symbols() {
                let symbols = {0: {}, 1: {}};

                let index = 0;
                for (const [key, value] of Object.entries(this.odds.symbols)) {
                    if(index < 4) {
                        symbols[0][key] = value;
                    } else {
                        symbols[1][key] = value;
                    }

                    index++;
                }

                return symbols;
            }
        }
    }
</script>

<style>
    .cleopatra-paytable .amount {
        color: white;
        font-size: 14px;
        font-weight: bold;
    }
    
    .cleopatra-paytable img {
        padding:0px;
    }

    .cleopatra-paytable h6 {
        font-size: 14px;
    }

    .cleopatra-paytable .side-note {
        line-height: 1.2;
    }

    .cleopatra-paytable .span {
        font-size: 11px;
    }
</style>